import { useStanQuery } from '@/queries';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import { fetchOptInEmailTemplate } from '@/lib/api/email-flows';

/**
 * Query hook for fetching opt-in email template
 */
export const useOptInEmailTemplate = () => {
    return useStanQuery(
        {
            queryKey: [QUERY_KEYS.EMAIL_TEMPLATE_VARIABLES, 'opt_in_email_template'],
            queryFn: fetchOptInEmailTemplate,
            staleTime: 1000 * 60 * 30, // 30 minutes
            meta: {
                error: {
                    sentryMessage: '[EMAIL_FLOWS] Failed to fetch opt-in email template',
                    title: 'Error Loading Template',
                    message: 'Unable to load opt-in email template. Please try again.',
                    feature: SENTRY_FEATURES.EMAIL_FLOWS,
                },
            },
        },
        true
    );
};
